"use client";

import { BattleBoard, type ActiveCell } from "./BattleBoard";
import { NextPiece } from "./NextPiece";
import { TouchControls, type LegacyAction } from "./TouchControls";

export type BoardView = {
  active: ActiveCell[];
  board: number[][];
  nextCells: ReadonlyArray<readonly [number, number]>;
  nextPiece: number;
  pending: number;
  received: number;
  topOut: boolean;
};

type BattleArenaProps = {
  controlsEnabled: boolean;
  localSeat: 1 | 2;
  onInput: (action: LegacyAction, held: boolean) => void;
  p1: BoardView;
  p2: BoardView;
  quality: string;
};

export function BattleArena({
  controlsEnabled,
  localSeat,
  onInput,
  p1,
  p2,
  quality,
}: BattleArenaProps) {
  return (
    <div className="match-shell">
      <div className="arena">
        <BattleBoard
          active={p1.active}
          board={p1.board}
          label={localSeat === 1 ? "PLAYER 1 / YOU" : "PLAYER 1"}
          local={localSeat === 1}
          topOut={p1.topOut}
        />

        <aside aria-label="対戦情報" className="versus-column">
          <NextPiece cells={p1.nextCells} label="P1 NEXT" piece={p1.nextPiece} />
          <div className="metrics">
            <div className="metric">
              <span className="metric-label">P1 IN</span>
              <strong>{p1.pending}</strong>
            </div>
            <div className="metric">
              <span className="metric-label">P2 IN</span>
              <strong>{p2.pending}</strong>
            </div>
            <div className="metric">
              <span className="metric-label">P1 TOTAL</span>
              <strong>{p1.received}</strong>
            </div>
            <div className="metric">
              <span className="metric-label">P2 TOTAL</span>
              <strong>{p2.received}</strong>
            </div>
          </div>
          <div aria-hidden="true" className="vs-mark">VS</div>
          <NextPiece cells={p2.nextCells} label="P2 NEXT" piece={p2.nextPiece} />
          <span className="connection-status">{quality}</span>
        </aside>

        <BattleBoard
          active={p2.active}
          board={p2.board}
          label={localSeat === 2 ? "PLAYER 2 / YOU" : "PLAYER 2"}
          local={localSeat === 2}
          topOut={p2.topOut}
        />
      </div>

      <div className="controls-row">
        {localSeat === 1 ? (
          <TouchControls disabled={!controlsEnabled} onInput={onInput} side="left" />
        ) : (
          <span />
        )}
        {localSeat === 2 ? (
          <TouchControls disabled={!controlsEnabled} onInput={onInput} side="right" />
        ) : (
          <span />
        )}
      </div>
    </div>
  );
}
